import { useEffect, useState } from 'react';
import { Menu, X, Sigma } from 'lucide-react';

// 导航栏：固定顶部，点击平滑滚动到对应锚点
const navItems = [
  { id: 'hero', label: '首页' },
  { id: 'background', label: '背景' },
  { id: 'product', label: '方案' },
  { id: 'demo', label: '演示' },
  { id: 'market', label: '市场' },
  { id: 'business', label: '模式' },
  { id: 'finance', label: '财务' },
  { id: 'team', label: '团队' },
  { id: 'roadmap', label: '规划' },
];

export default function Navbar() {
  const [active, setActive] = useState('hero');
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + window.innerHeight / 3;
      for (let i = navItems.length - 1; i >= 0; i--) {
        const el = document.getElementById(navItems[i].id);
        if (el && el.offsetTop <= scrollY) {
          setActive(navItems[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setActive(id);
      setMobileOpen(false);
    }
  };

  return (
    <nav className="navbar flex items-center justify-between">
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={() => scrollTo('hero')}
      >
        <Sigma className="w-7 h-7 text-gold" />
        <span className="text-xl font-bold text-white tracking-wider">
          数师有方
        </span>
      </div>

      {/* 桌面导航 */}
      <div className="hidden lg:flex items-center gap-1">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => scrollTo(item.id)}
            className={`nav-link ${active === item.id ? 'active' : ''}`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* 移动端菜单按钮 */}
      <button
        className="lg:hidden text-white"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* 移动端下拉 */}
      {mobileOpen && (
        <div className="absolute top-full left-0 w-full bg-deepBlue/95 border-b border-gold/10 p-4 lg:hidden flex flex-col gap-2">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`nav-link text-left ${active === item.id ? 'active' : ''}`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
